/**
  * @class mmodSplash
  * @description
  * Splash Screen module shows temporary information screen while other modules load on application start.
  * It is used in both, mOffice and mPatrol the same way.
  * Splash Screen module is implemented without workflow, as a pure module named mmodSplash.
  * It listens for mmStartedAll message indicating that all listeners were started and then deletes itself.
  */

import mmodModule from 'mmodModule'
import { App } from '@capacitor/app'

export default class mmodSplash extends mmodModule {
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates an instance of the class.
  * @param {string} [id] - ID under which the object will listen for messages
  * @param {string} [cfg] - object initial configuration
  * @param {string} [cfg_schema] - additional schema properties from derived classes
  * @param {string} [dependencies] - additional dependencies from derived classes
  */
  constructor(id, cfg, cfg_schema, dependencies) {
    dependencies = _.union([], dependencies)
    cfg_schema = _.extend({
      logo: { type: 'string', description: 'Icon for logo', default: 'mosy_mosy' },
      title: { type: 'string', description: 'A title displayed below logo', default: '' },
      copyright: { type: 'string', description: 'Copyright note', default: `(c) Mosy ${new Date().getFullYear()}` },
      min_time: { type: 'number', description: 'Minimum time that splash is displayed', default: 10 },
      init: {
        type: 'object',
        default: {
          type: 'float',
          x: 0,
          y: 0,
          width: '100%',
          height: '100%',
          order: 0,
        },
        description: 'Initial window setup; same structure as required by `mmWindowSet`',
      },
    }, cfg_schema)
    super(id, cfg, cfg_schema, dependencies)
  } // constructor

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * @description
  * initialization of GUI components
  */
  initWindow() {
    if(!this.el) return
    this.killAppListener()

    this.startDT = Date.now()

    this.el.updateProperties({
      layout: 'single',
      views: 'single',
      items: [
        {
          tag: 'mele-image',
          key: 'logo',
          icon: 'LOGO',
        },
        {
          tag: 'mele-image',
          key: 'applogo',
          icon: this.config.logo,
        },
        {
          tag: 'div',
          class: 'title',
          children: [this.config.title],
        },
        {
          tag: 'div',
          class: 'copyright',
          children: [this.config.copyright],
        },
      ],
    })

    this.mmStart()
  } // initWindow

  killAppListener() {
    let click_count = 0
    let timeout
    const pass = 'nev123mosy'
    this.el.onclick = ()=> {
      if(timeout) clearTimeout(timeout)
      click_count++
      if(click_count == 7) {
        const modal = this.el.modalOpen({
          header: 'Kill App',
          items: [
            { tag: 'mele-input', key: 'pass', label: 'password' },
          ],
          footerbuttons: ['cancel', 'submit'],
        })

        modal.eventSubmit = async (self, key, values)=> {
          if(values.pass == pass) await App.exitApp()
        }
      }
      timeout = setTimeout(()=> {
        click_count = 0
        clearTimeout(timeout)
      }, 200)
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * @description
  * Automatically invoked when all expected listeners were started or exited
  * @param {object} sender - message sender
  * @param {object} params - message parameters
  * @param {integer} [params.init] - timestamp when application starts with loading listeners
  * @param {integer} [params.loaded] - timestamp when all listeners are loaded and first listener starts
  * @param {integer} [params.started] - timestamp when all listeners started
  */
  mmStartedAll(sender, params) {
    // hide splash window when all modules loaded
    const delay = _.max([0, this.config.min_time - (Date.now() - this.startDT)])
    setTimeout(()=>{
      this.mmExit()
      this.el.deleteElement()
      delete this.el
    }, delay)
  } // mmStartedAll
} // mmodSplash
